import type { ClaimCategory, SuggestedItem } from '../../services/claimableItemsService';

// ── Category display helpers ──────────────────────────────────────────────────

export const CAT_LABELS: Record<ClaimCategory, string> = {
  product: 'Product', method: 'Method', programme: 'Programme',
  storage_medium: 'Medium', computer: 'Computer', use: 'Use',
};
export const CAT_OPTIONS: ClaimCategory[] = ['product', 'method', 'programme', 'storage_medium', 'computer', 'use'];
export const CAT_COLORS: Record<ClaimCategory, string> = {
  product: '#3730a3', method: '#065f46', programme: '#7c3aed',
  storage_medium: '#92400e', computer: '#1e40af', use: '#6b7280',
};
export const CAT_BG: Record<ClaimCategory, string> = {
  product: '#e0e7ff', method: '#d1fae5', programme: '#ede9fe',
  storage_medium: '#fef3c7', computer: '#dbeafe', use: '#f1f5f9',
};

// ── Shared button styles ──────────────────────────────────────────────────────

export const btnPrimary = {
  fontSize: 11, padding: '3px 12px', borderRadius: 3,
  border: '1px solid #2563eb', background: '#2563eb', color: '#fff',
  fontWeight: 600, cursor: 'pointer',
} as const;
export const btnSecondary = {
  fontSize: 11, padding: '3px 12px', borderRadius: 3,
  border: '1px solid #cbd5e1', background: '#f8fafc', color: '#475569',
  fontWeight: 500, cursor: 'pointer',
} as const;
export const btnDanger = {
  fontSize: 10, padding: '2px 7px', borderRadius: 3,
  border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626', cursor: 'pointer',
} as const;

// ── CFA message types ─────────────────────────────────────────────────────────

export type CFARole = 'assistant' | 'user' | 'suggestions';
export interface CFAMessage {
  id: string;
  role: CFARole;
  text?: string;
  suggestions?: SuggestedItem[];
}
